import { generateUniqueId } from '@/helpers/uuidUtils';

export class Compatibility {
  public id: UUID;
  public type: CompatibilityType;
  public isCompatible?: boolean;
  public reason?: string;
  public note?: string;

  constructor() {
    this.id = generateUniqueId();
    this.type = CompatibilityType.SMART_HEATING;
    this.isCompatible = true;
    this.reason = undefined;
    this.note = undefined;
  }
}

export enum CompatibilityType {
  SMART_HEATING = 'SMART_HEATING',
}
